import StatGrid from '@commons/stats'
import Column from '@components/column'
import SectionHeading from '@commons/headings/section'
import Table from '@components/table'
import { User } from '@apis'
import debounce from '@utils/debounce'
import { useSelector } from 'react-redux'
import { useEffect, useState } from 'react'
import { Formik } from 'formik'
import Fields from '@components/fields'
const AdminPatientsPage = () => {
  const { items: patients } = useSelector((state: any) => state.patients)
  const [params, setParams] = useState({
    page: 1,
    limit: 10,
    role: 'patient',
    isApproved: true,
    search: '',
  })
  const items: any = [
    {
      title: 'Total Patient',
      value: '155',
      icon: 'doctor',
      bg: 'secondary50',
    },
    {
      title: 'No. of Male Patient',
      value: '23',
      icon: 'doctor',
      bg: 'green50',
    },
    {
      title: 'No. of Female Patient',
      value: '23',
      icon: 'doctor',
      bg: 'danger50',
    },
    {
      title: 'Total Active Payment',
      value: '23',
      icon: 'doctor',
      bg: 'yellow50',
    },
  ]
  const columns = [
    {
      key: 'name',
      title: 'Name',
    },
    {
      key: 'address',
      title: 'Address',
      render: (item: any) => {
        return item?.infos?.address
      },
    },
    {
      key: 'phoneNo',
      title: 'Phone No',
    },
    {
      key: 'age',
      title: 'Age',
      render: (item) => {
        return item.infos.age
      },
    },
    {
      key: 'bloodGroup',
      title: 'Blood Group',
      render: (item) => {
        return item.infos.bloodGroup
      },
    },
    {
      key: 'status',
      title: 'Active Status',
      render: (item) => {
        return (
          <Formik
            initialValues={{
              isActive: item?.isActive,
            }}
            onSubmit={() => {}}
          >
            {() => {
              return (
                <Fields.Switch
                  name="isActive"
                  onChange={async (value) => {
                    await User.updateStatus({
                      state: 'patients',
                      id: item?.id,
                      action: 'update',
                      data: {
                        isActive: value,
                      },
                    })
                  }}
                />
              )
            }}
          </Formik>
        )
      },
    },
  ]
  const fetchPatients = async (params) => {
    await User.list({
      params: params,
      state: 'patients',
    }).catch(() => {})
  }

  const handleSearch = debounce(async (event: any) => {
    const text = event.target.value
    const updateParams = {
      ...params,
      search: text,
    }
    await fetchPatients(updateParams)
    setParams(updateParams)
  }, 500)

  useEffect(() => {
    if (!patients?.length) {
      fetchPatients(params)
    }
  }, [])
  return (
    <>
      <StatGrid items={items} />
      <Column styleColumn="margin-top:20px;margin-bottom:20px;">
        <SectionHeading title="Patients Management" />
      </Column>
      <Table
        columns={columns}
        data={patients}
        filter={{
          hasSearch: true,
          onSearch: handleSearch,
        }}
      />
    </>
  )
}

export default AdminPatientsPage
